import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { forgotAdmin } from "../../../store/features/auth/authSlice";
import { showToast } from "../../../store/features/toast/toastSlice";
// actions


import Constant from '../../../util/constant';
import ForgotPasswordComponent from "./forgotPasswordComponent";

/**
 * A container component for the Forgot Password feature.
 * @param {object} props - The props passed to the component.
 * @returns The rendered ForgotPasswordComponent with the necessary props.
 */
const ForgotPasswordContainer = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [busy, setBusy] = useState(false);
  window.sessionStorage.setItem(Constant.SESSIONSTORAGEKEYS.RESET_PASS, '');
  window.sessionStorage.setItem(
    Constant.SESSIONSTORAGEKEYS.EVENTS_OTP_VERIFIED,
    "false"
  );


  useEffect(() => {
    localStorage.clear()
  },[])

  /**
   * Handles the form submission event and performs the necessary actions.
   * @param {Object} value - The form value object containing the email.
   * @returns None
   */
  const onFormSubmit = async (value) => {
    setBusy(true);
   dispatch(forgotAdmin(value?.email)).then((resultAction) => {
    if(forgotAdmin.fulfilled.match(resultAction)) {
      window.sessionStorage.setItem(
        Constant.SESSIONSTORAGEKEYS.FORGOT_EMAIL,
        resultAction?.payload?.data?.email || value?.email || ""
      );
      window.sessionStorage.setItem(Constant.SESSIONSTORAGEKEYS.OTP, resultAction?.payload?.data?.otp);
      window.sessionStorage.setItem(Constant.SESSIONSTORAGEKEYS.RESET_TOKEN, resultAction?.payload?.data?.resetToken);
      window.sessionStorage.setItem(
        Constant.SESSIONSTORAGEKEYS.OTP_REQUEST_ID,
        resultAction?.payload?.data?.otpRequestId || ""
      );
      dispatch(
        showToast({
          show: false,
          message: resultAction?.payload?.message,
          type: "success",
        })
      );
      setBusy(false);
      navigate("/otp-verification");
    } else if (forgotAdmin.rejected.match(resultAction)) {
      setBusy(false);
      dispatch(showToast({
        show:false,
        message:  resultAction?.error?.message,
        type: "error",
      }),
    );
    }
   })
  };
  const forgotPassForm = {
    email: {
      name: "email",
      validate: {
        required: {
          value: true,
          message: t('EMAIL_ADRESS_REQUIRED'),
        },
        pattern: {
          value: Constant.REGEX.EMAIL,
          message: t('PLEASE_ENTER_A_VALID_EMAIL_ADDRESS')
        },
      },
    },
  };
  return (
    <ForgotPasswordComponent
      busy={busy}
      onFormSubmit={onFormSubmit}
      forgotPassForm={forgotPassForm}
    />
  );
};



export default ForgotPasswordContainer;
